import Vue from 'vue'
import Router from 'vue-router'

// security

import Login from './views/security/Login.vue'
import Logout from './views/security/Logout.vue'
import Confirm from './views/security/Confirm.vue'
import RegistrationSuccess from './views/security/success.vue'
import RegistrationNew from './views/registration/new'

//password

import RecoverSend from './views/security/recoverSend.vue'
import RecoverConfirm from './views/security/recoverConfirm.vue'
import RecoverEdit from './views/security/recoverEdit.vue'

import Home from './views/Home.vue'
import Payments from './views/payments.vue'

import UserNew from './views/users/new'
import UserEdit from './views/users/edit'
import UserSuccess from './views/users/success'

import ClassesNew from './views/classes/new'
import ClassesSuccess from './views/classes/success'

import Account from './views/account'

// Admin

import AdminIndex from './views/admin/index'
import AdminUserEdit from './views/admin/adminUserEdit'
import adminAddCourse from './views/admin/adminAddCourse'
import AdminFamiliesEdit from './views/admin/adminFamiliesEdit'
import AdminAccount from './views/admin/adminAccount'
import AdminAdministrators from './views/admin/adminAdministrators'
import AdminCourses from './views/admin/adminCourses'
import AdminOptions from './views/admin/adminOptions'
import AdminProfessors from './views/admin/adminProfessors'
import AdminConfirm from './views/admin/adminConfirm'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
        },
        {
            path: '/paiements',
            name: 'Payments',
            component: Payments,
        },

        // Users
        {
            path: '/personnes/ajouter',
            name: 'users.new',
            component: UserNew,
            meta: {isSecondary: true}
        },

        {
            path: '/personnes/:id',
            name: 'users.edit',
            component: UserEdit,
            meta: {isSecondary: true}
        },

        {
            path: '/confirmation/:id',
            name: 'users.success',
            component: UserSuccess
        },

        // Compte

        {
            path: '/mon-compte',
            name: 'account',
            component: Account,
            meta: {isSecondary: true}
        },

        // Classes

        {
            path: '/ajouter-cours/:id',
            name: 'classes.new',
            component: ClassesNew,
            meta: {isSecondary: true},
        },
        {
            path: '/ajout-cours-succes/:id/:course_id',
            name: 'classes.success',
            component: ClassesSuccess,
        },

        // Connexion
        {
            path: '/connexion',
            name: 'Login',
            meta: {layout: "security"},
            component: Login
        },
        {
            path: '/deconnexion',
            name: 'Logout',
            meta: {layout: "security"},
            component: Logout
        },
        {
            path: '/confirm',
            meta: {layout: "security"},
            name: 'Confirm',
            component: Confirm
        },

        // Mot de passe

        {
            path: '/reinitialiser-mdp',
            meta: {layout: "security"},
            name: 'recover.send',
            component: RecoverSend
        },

        {
            path: '/recover-password',
            meta: {layout: "security"},
            name: 'recover.confirm',
            component: RecoverConfirm
        },
        {
            path: '/nouveau-mdp',
            meta: {layout: "security"},
            name: 'recover.edit',
            component: RecoverEdit
        },


        // registration
        {
            path: '/inscription',
            name: 'registration.new',
            meta: {layout: "security"},
            component: RegistrationNew
        },
        {
            path: '/inscription/succes',
            name: 'RegistrationSuccess',
            meta: {layout: "security"},
            component: RegistrationSuccess
        },


        // Admin

        {
            path: '/admin',
            name: 'admin.index',
            meta: {layout: "list-dancer"},
            component: AdminIndex
        },
        {
            path: '/admin/users/:id',
            name: 'admin.users.edit',
            meta: {layout: "admin"},
            component: AdminUserEdit
        },
        {
          path: '/admin/ajouter-cours/:id',
          name: 'admin.courses.new',
          meta: {layout: "admin"},
          component: adminAddCourse
        },
        {
            path: '/admin/families/:id',
            name: "admin.families.edit",
            meta: {layout: "admin"},
            component: AdminFamiliesEdit
        },
        {
            path: '/admin/account',
            name: "admin.account",
            meta: {layout: "admin"},
            component: AdminAccount
        },

        // Administration
        {
            path: "/admin/administrators",
            name: 'admin.administrators',
            meta: {layout: "admin", isSecondary: true},
            component: AdminAdministrators
        },
        {
            path: "/admin/courses",
            name: 'admin.courses',
            meta: {layout: "admin", isSecondary: true},
            component: AdminCourses
        },
        {
            path: "/admin/professors",
            name: 'admin.professors',
            meta: {layout: "admin", isSecondary: true},
            component: AdminProfessors
        },
        {
            path: "/admin/options",
            name: 'admin.options',
            meta: {layout: "admin", isSecondary: true},
            component: AdminOptions
        },
        {
            path: '/confirm-admin',
            name: 'admin.confirm',
            meta: {layout: "security"},
            component: AdminConfirm
        }

    ]
})
